import {RouteContext} from "../../RouteContext";
import {ListPage} from "../common/ListPage";
import {ShoppingValueObject} from "../../../model/vo/content/ShoppingValueObject";
import {ShoppingIO} from "../../../io/content/ShoppingIO";
import {
    Button,
    Switch,
} from "@fluentui/react-components";
import {useError, useStatePair} from "../../../type/States";
import {Column, Row} from "../common/Layout";
import {HttpClient} from "../../../io/HttpClient";
import { Types} from "../../../type/Types";
import TruncateText from "../common/TruncateText";
import {AddFilled} from "@fluentui/react-icons";
import TotalMetricDialog from "../common/TotalMetricDialog";


export default function List(props: RouteContext) {
    const isActiveState = useStatePair<Map<bigint, boolean>>(new Map<bigint, boolean>())
    const uploadErrorState = useError()

    const setActive = (id: bigint, isActive: boolean) => {
        const acc = new Map<bigint, boolean>(isActiveState.value)
        acc.set(id, isActive)
        isActiveState.setValue(acc)
    }

    const json = require('json-bigint')({
        alwaysParseAsBig: true,
        useNativeBigInt: true
    })

    return <>
        <Column gap={'16px'}>
            <Row gap={'8px'}>
                <Button
                    as={'a'}
                    appearance={'primary'}
                    icon={<AddFilled />}
                    href={'/admin/shoppings/pulym'}
                    target={'_blank'}>
                    풀림데이터 가져오기
                </Button>
                <Button
                    as={'a'}
                    appearance={'primary'}
                    icon={<AddFilled />}
                    href={'/admin/shoppings/nsrt'}
                    target={'_blank'}>
                    nsrt 포스트백
                </Button>
                <TotalMetricDialog />
            </Row>
            <ListPage
                {...props}
                description={ShoppingValueObject.description}
                list={ShoppingIO.list}
                count={ShoppingIO.count}
                deleteIds={ShoppingIO.deleteIds}
                updateIds={(ids:bigint[],wishState: boolean)=>{
                    const body = {ids: ids, wishState: wishState}

                    fetch(`${process.env.REACT_APP_API_HOST}/api/v3/contents/shoppings/states`,
                        { method:'PATCH',
                            headers: {
                                'Content-Type': 'application/json',},
                            credentials: 'include',
                            body: Types.asUndefined(body, json.stringify) })
                        .then(async response => {
                            if (response.ok) {
                                alert('수정 성공')
                                window.location.reload()
                            } else {
                                throw new Error(await response.text())
                            }
                        })
                        .catch(uploadErrorState.setDefinedValue)
                }}
                postHref={'/admin/shoppings/post'}
                detailHref={item => `/admin/shoppings/${item.id}`}
                editHref={item => `/admin/shoppings/edit/${item.id}`}
                itemValue={(item, key) => {
                    if (key === 'isActive') {
                        const present = isActiveState.value.get(item.id)

                        if (present !== undefined) {
                            return <>
                                <Switch
                                    checked={present}
                                    onChange={(ev, data) =>
                                    {
                                        const id = Number(item.id.toString().split('n')[0])

                                        fetch(`${process.env.REACT_APP_API_HOST}/api/v3/contents/shoppings/states`,
                                            {
                                                method: 'PATCH',
                                                headers: {
                                                    'Content-Type': 'application/json',
                                                },
                                                credentials: 'include',
                                                body: Types.asUndefined({
                                                    wishState: data.checked,
                                                    ids: [id],
                                                }, json.stringify)
                                            }
                                        )
                                            .then(async value => {
                                                const res = await value.json()
                                                console.log(res)

                                                if(!res){
                                                    return
                                                }

                                                setActive(item.id, data.checked)

                                            })
                                    }
                                }

                                />
                            </>
                        } else {
                            return <>
                                <Switch
                                    checked={item.isActive}
                                    onChange={(ev, data) =>
                                    {
                                        const id = Number(item.id.toString().split('n')[0])

                                        fetch(`${process.env.REACT_APP_API_HOST}/api/v3/contents/shoppings/states`,
                                            {
                                                method: 'PATCH',
                                                headers: {
                                                    'Content-Type': 'application/json',
                                                },
                                                credentials: 'include',
                                                body: Types.asUndefined({
                                                    wishState: data.checked,
                                                    ids: [id],
                                                }, json.stringify)
                                            }
                                        )
                                            .then(async value => {
                                                const res = await value.json()
                                                console.log(res)

                                                if(!res){
                                                    return
                                                }

                                                setActive(item.id, data.checked)

                                            })
                                    }
                                } />
                            </>
                        }
                    }
                    else if(key === 'productImageUrl' || key == 'productUrl' ){
                        return <TruncateText text={item[key] || ''} maxLength={20}/>
                    }
                    else {
                        return undefined
                    }
                }}
                uploadSheetUrls={[
                    { name: '엑셀 생성 업로드', url: `${process.env.REACT_APP_API_HOST}/api/v3/contents/shoppings/excel`, method: 'POST' },
                    { name: '엑셀 수정 업로드', url: `${process.env.REACT_APP_API_HOST}/api/v3/contents/shoppings/excel`, method: 'PUT'},
                ]}
                downloadSheetUrl={(searchConditions, sortOrders, offset,count) =>
                    HttpClient.buildUrl(
                        `${process.env.REACT_APP_API_HOST}/api/v3/contents/shoppings/excel`,
                        searchConditions,
                        sortOrders,
                        count,
                        offset,
                    )}
                downloadSheetExampleUrls={[
                    { name: '생성 액셀 양식', url: `${process.env.REACT_APP_API_HOST}/api/v3/contents/shoppings/excel/example/post`, },
                    { name: '수정 액셀 양식', url: `${process.env.REACT_APP_API_HOST}/api/v3/contents/shoppings/excel/example/put`, },
                ]}
                excelExportUrl={(searchConditions, sortOrders, offset,count) =>
                    HttpClient.buildUrl(
                        `${process.env.REACT_APP_API_HOST}/api/v3/contents/shoppings/excels/export`,
                        searchConditions,
                        sortOrders,
                        count,
                        offset,
                )}
                initialSearchConditions={[
                    {
                        name: 'deletedAt',
                        value: '',
                        condition: 'IsNull'
                    },
                ]}
                initialSortOrders={[
                    {
                        name: 'exposedAt',
                        order: 'DESC'
                    }
                ]}
            />
        </Column>
    </>
}